import { TMSOrderStatus } from "@/types";

export const OrderStatusColorMap = {
  [TMSOrderStatus.Deleted]: "red",
  [TMSOrderStatus.Created]: "orange",
  [TMSOrderStatus.Processing]: "blue",
  [TMSOrderStatus.Completed]: "green",
};
